<template>
    <footer>
        <div class="container">
            <div class="text-center menu-footer" v-if="$isAis">
                <a href="http://www.ais.co.th/fibre/support.html" target="_blank">FAQ</a>
                <a href="http://www.ais.co.th/fibre/contact.html" target="_blank">AIS Call Center 1175</a>
            </div>
            <p class="text-footer">© {{year}} {{companyName}}. ALL RIGHTS RESERVED. <br> This site is best viewed using Internet Explorer 9, Chrome, Safari and browser later.</p>
        </div>
    </footer>
</template>

<script>
import devConfig from '@/devConfig'
export default {
    data() {
        return {
            year: new Date().getFullYear() || 2018,
            isAis:true,
            companyName:''
        }
    },
    created(){
        devConfig.init(this, () => {
            if(devConfig.getData().area === 'TOT')
                this.companyName = 'TOT PUBLIC COMPANY LIMITED'
            else if(devConfig.getData().area === 'AIS')
                this.companyName = 'ADVANCED INFO SERVICE PLC'
            else
                this.companyName = 'Fiberhome'
        })
    }
}
</script>


<style src="../assets/style/footer.css"></style>